import API from "./index"

class AlmoxarifadoProdutoService {
  constructor() {
    this.path = `api/almoxarifados/produtos`
  }

  async findAll({ page = 0, size = 10, filter = false, params = {} }) {
    params.page = page - 1 < 0 ? 0 : page - 1
    params.size = size
    filter ? (params.filter = filter) : null

    const response = await API.get(this.path, {
      params,
      responseEncoding: false,
    })
    return response
  }
  find() {
    return API.get(`${this.path}`)
  }
  findById(id) {
    return API.get(`${this.path}/${id}`)
  }

  save(record) {
    if (record.id) {
      return API.put(`${this.path}/${record.idProduto}`, record).then(
        ({ ...args }) => ({ created: false, ...args })
      )
    }

    return API.post(this.path, record).then(({ ...args }) => ({
      created: true,
      ...args,
    }))
  }

  remove(idProduto) {
    if (!idProduto) {
      throw new Error("Produto não encontrado para o almoxarifado")
    }

    return API.delete(`${this.path}/${idProduto}`)
  }
}

export default AlmoxarifadoProdutoService
